'use client';
import * as e$1 from 'react';

let e = Math.random().toString(36).substring(2, 11), r = 0;
function setAutoIdSignature(t) {
    e = t;
}
function resetAutoId(t) {
    e = t, r = 0;
}
function generateId() {
    return r += 1, `auto-id-${e}-${r}`;
}
const useId = (e)=>{
    let [r, n] = e$1.useState(null != e ? e : void 0);
    return e$1.useEffect(()=>{
        n((t)=>t || generateId());
    }, []), r;
};

export { resetAutoId, setAutoIdSignature, useId };
